import { createContext, useReducer } from 'react';
import { medicalReducer } from '../reducers/medicalReducer';

import { medical, education, auth, cart } from '../initialState';
import { medicalActions, educationActions, authAction, cartAction } from '../actionType';
import { educationReducer } from '../reducers/educationReducer';
import { userReducer } from '../reducers/userReducer';
import { cartReducer } from '../reducers/cartReducer';

export const RootContext = createContext({
    medical: {
        selectBtn: "specialist"
    },
    saveSelectBtn: (btn) => { },

    education: {
        teacher: [],
        msg: ""
    },
    saveTeacher: (payload) => { },
    authValue: {
        user: null
    },
    saveUser: (user) => { },
    removeUser: () => { },
    //cart
    cart: [],
    updateCart: (data,count) => {},
    updateFullCart: (data) => {},
    removeCart: (data) => {},
    clearCart: () => {}

});

function RootContextProvider({ children }) {
    const [medicalState, medicalDispatch] = useReducer(medicalReducer, medical);
    const [educationState, educationDispatch] = useReducer(educationReducer, education);
    const [authState, authDispatch] = useReducer(userReducer, auth);
    const [cartState, cartDispatch] = useReducer(cartReducer,cart);

    const value = {
        //medical
        medical: medicalState,
        saveSelectBtn: (btn) => medicalDispatch({ type: medicalActions.SAVE_SELECT_BTN, payload: btn }),
        education: educationState,
        saveTeacher: (payload) => educationDispatch({ type: educationActions.SAVE_TEACHER, payload: payload }),
        authValue: authState,
        saveUser: (payload) => authDispatch({ type: authAction.SAVE_USER, payload: payload }),
        removeUser: () => authDispatch({ type: authAction.REMOVE_USER }),
        cart: cartState,
        updateCart: (data, count) => cartDispatch({type: cartAction.UPDATE_CART, payload:{data,count}}),
        updateFullCart: (data) => cartDispatch({type: cartAction.UPDATE_FULL_CART, payload:{data}}),
        removeCart: (data) => cartDispatch({type: cartAction.REMOVE_CART, payload:{data}}),
        clearCart: () => cartDispatch({type: cartAction.CLEAR_CART})
    }

    return <RootContext.Provider value={value}>
        {children}
    </RootContext.Provider>
}

export default RootContextProvider;